import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './App';
import { AuthProvider } from './context/AuthContext';
import { StaffAuthProvider } from './context/StaffAuthContext';
import { ErpAuthProvider } from './context/ErpAuthContext';
import { ChatUiProvider } from './context/ChatUiContext';
import './styles/global.css';
import './components/layout/layouts.css';
import './styles/marketing.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <StaffAuthProvider>
          <ErpAuthProvider>
            <ChatUiProvider>
              <AppRoutes />
            </ChatUiProvider>
          </ErpAuthProvider>
        </StaffAuthProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);
